import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const FirewallUsageChart = () => {
  const data = [
    { reason: "Mangelndes Bewusstsein für Sicherheitsrisiken", percentage: 70 },
    { reason: "Nutzer verlässt sich auf integrierten Grundschutz", percentage: 50 },
    {
      reason:
        "Schutz durch Router mit Network Address Translation-Funktionalität. NAT verhindert, dass Geräte im internen Netzwerk (z. B. Laptop, Drucker, Server) von außen erreichbar sind.",
      percentage: 45,
    },
    { reason: "Befürchtung von Performance-Einbußen", percentage: 35 },
    { reason: "Komplexität der Konfiguration", percentage: 30 },
    { reason: "Zusätzliche Kosten für Hardware-Firewalls", percentage: 20 },
    { reason: "Nutzer verlässt sich auf andere Sicherheitsmaßnahmen", percentage: 10 },
  ];

  return (
    <div className="container mt-3">
      <h4 className="mb-4">
        Warum nutzen so wenig Privatanwender eine Firewall?
      </h4>
      {data.map((item, index) => (
        <div key={index} className="mb-3">
          <div className="d-flex justify-content-between mb-1">
            <span>{item.reason}</span>
            <span>{item.percentage}%</span>
          </div>
          <div className="progress progress-chart">
            <div
              className="progress-bar bg-info"
              role="progressbar"
              style={{ width: `${item.percentage}%` }}
              aria-valuenow={item.percentage}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FirewallUsageChart;
